module.exports = __webpack_public_path__ + "static/media/joel-trzcinski-ef.475dfbb4.mp4";